import styled from "styled-components";

const ToastContainer = styled.div`
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  min-width: 240px;
  padding: 16px;
  position: fixed;
  left: 20px;
  bottom: 20px;
  background: black;
  color: white;
`;

export default ToastContainer;
